//Smooth scroll
var smoothElems = document.querySelectorAll("[href='#trynow']");
if(smoothElems.length > 0) {
  for(let i=0; i<smoothElems.length; i++) {
    let smoothElem = smoothElems[i];
    smoothElem.addEventListener("click", function(e) {
      e.preventDefault();
      let toElem = document.querySelector(this.getAttribute("href"));
      console.log(toElem);
      toElem.scrollIntoView({
        behavior: 'smooth'
      });
    })
  }
}